

export const logo = {
    code: "elfin_tmpl_img_12",
    image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flogo%20(1).png?alt=media&token=f8ca9009-e66f-4c79-95be-e9d2a7e8fefd"
}

export const bannerImages = {
    sm: {
        code: "elfin_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fmoobile%20banner.jpg?alt=media&token=5685426f-85b5-4201-a6f9-d2f4d1addf4f",
    },
    lg: {
        code: "elfin_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fweb%20banner.jpg?alt=media&token=c22a7fdd-fc39-4842-a157-e1efafa6c8f3",
    }
}

export const productImages = {
    p1: {
        code: "elfin_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F1.jpg?alt=media&token=0cfd76ff-e182-4b58-83c4-09794f702d95"
    },
    p2: {
        code: "elfin_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F2.jpg?alt=media&token=d3ad53ed-d70e-42d5-9f84-44581488ab7f",
    },
    p3: {
        code: "elfin_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F2.jpg?alt=media&token=d3ad53ed-d70e-42d5-9f84-44581488ab7f",
    },
    p4: {
        code: "elfin_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F4.jpg?alt=media&token=0d6161be-372a-48d8-aae6-03682bceceb0",
    },
    p5: {
        code: "elfin_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F5.jpg?alt=media&token=aba5039f-fdae-4218-9faa-4035602f936d",
    },
    p6: {
        code: "elfin_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F6.jpg?alt=media&token=a0efbab5-08d8-479a-8a54-9299fcb57090",
    },
    p7: {
        code: "elfin_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F7.jpg?alt=media&token=f106544f-7f35-4a6d-9f9a-22661527bada",
    },
}

export const products = [
    {
        id: "one",
        name: "Product1",
        price: "20,000 MMK",
        image: productImages.p1.image
    },
    {
        id: "two",
        name: "Product2",
        price: "40,000 MMK",
        image: productImages.p2.image
    },
    {
        id: "three",
        name: "Product3",
        price: "28,000 MMK",
        image: productImages.p2.image,
    },
    // {
    //     id: "four",
    //     name: "Product4",
    //     price: "45,000 MMK",
    //     image: productImages.p4.image,
    // },
    {
        id: "five",
        name: "Product5",
        price: "45,000 MMK",
        image: productImages.p5.image,
    },
    {
        id: "six",
        name: "Product6",
        price: "45,000 MMK",
        image: productImages.p6.image,
    },
    {
        id: "seven",
        name: "Product7",
        price: "45,000 MMK",
        image: productImages.p7.image,
    },
]

export const categories=[
    {id:"one",name:"Sport Wear"},
    {id:"two",name:"Accessories"},
    {id:"three",name:"Short Pants"},
    {id:"four",name:"Long Pants"},
    {id:"five",name:"Sport Bras"}
];